export const AccordionHeader = require('./Header').default;
export const AccordionContent = require('./Content').default;

export default {
  AccordionHeader,
  AccordionContent,
};



// WEBPACK FOOTER //
// ./src/App/account/components/Accordion/DefaultComponents/index.js